import { useId } from "react"
import { brandControlLabelClassName } from "@/components/ui/brand-typography"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { DISPLAY_PERIOD_OPTIONS } from "@/lib/display-period"
import { cn } from "@/lib/utils"
import { type BrandDashboardPeriod, useUserPreferencesStore } from "@/state/store/userPreferences"

interface BrandDisplayPeriodControlProps {
  className?: string
  triggerClassName?: string
  hideLabel?: boolean
}

export function BrandDisplayPeriodControl({
  className,
  triggerClassName,
  hideLabel = false,
}: BrandDisplayPeriodControlProps) {
  const labelId = useId()
  const defaultBrandDashboardPeriod = useUserPreferencesStore((state) => state.defaultBrandDashboardPeriod)
  const setDefaultBrandDashboardPeriod = useUserPreferencesStore((state) => state.setDefaultBrandDashboardPeriod)

  return (
    <div className={cn("flex w-full flex-wrap items-center gap-2 sm:w-auto", className)}>
      {hideLabel ? null : (
        <span id={labelId} className={brandControlLabelClassName}>
          Display Period
        </span>
      )}
      <Select
        value={defaultBrandDashboardPeriod}
        onValueChange={(value) => setDefaultBrandDashboardPeriod(value as BrandDashboardPeriod)}
      >
        <SelectTrigger
          variant="brand"
          size="sm"
          className={cn("w-full sm:w-[140px]", triggerClassName)}
          aria-label={hideLabel ? "Display Period" : undefined}
          aria-labelledby={hideLabel ? undefined : labelId}
        >
          <SelectValue placeholder="Select a period" />
        </SelectTrigger>
        <SelectContent>
          {DISPLAY_PERIOD_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
